module.exports = __webpack_public_path__ + "img/June 22-2.508d89e.png";